import { Box, Heading, Text } from '@chakra-ui/react'

// Shared hover treatment for interactive/clickable cards across DayN pages.
// Cards lift slightly and gain a shadow on hover to signal they are navigable.
export const cardHover = { transform: 'translateY(-4px)', shadow: 'xl' } as const

interface SectionHeadingProps {
  title: string
  description?: string
  /** Center the title/description (and constrain the description width). */
  centered?: boolean
}

// A small section wrapper so every block on a DayN page shares the same title /
// subtitle rhythm.
export function SectionHeading({ title, description, centered }: SectionHeadingProps) {
  return (
    <Box textAlign={centered ? 'center' : undefined}>
      <Heading size="md">{title}</Heading>
      {description ? (
        <Text color="content.secondary" maxW={centered ? '2xl' : undefined} mx={centered ? 'auto' : undefined}>
          {description}
        </Text>
      ) : null}
    </Box>
  )
}
